import { render, staticRenderFns } from "./SaleSummary.vue?vue&type=template&id=46381e53&scoped=true"
import script from "./SaleSummary.vue?vue&type=script&lang=js"
export * from "./SaleSummary.vue?vue&type=script&lang=js"
import style0 from "./SaleSummary.vue?vue&type=style&index=0&id=46381e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46381e53",
  null
  
)

export default component.exports